'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _regenerator = require('babel-runtime/regenerator');
var _regenerator2 = _interopRequireDefault(_regenerator);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _propTypes = require('prop-types');
var _updateForm = require('../actions/update-form');
var _submission = require('../actions/submission');
var _formInfo = require('../selectors/form-info');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint-disable react/jsx-no-bind */

var Form = function (_Component) {
  _inherits(Form, _Component);
  function Form(props) {
    var _this2 = this;
    _classCallCheck(this, Form);

    // Set default state
    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));
    _this.handleSubmit = function () {
      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(e) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (typeof e !== 'undefined') {
                  e.preventDefault();
                }
                if (_this.props.validating) {
                  _context.next = 4;
                  break;
                }
                _context.next = 4;
                return _this.props.submitForm(_this.props.id, _this.props.validator, _this.props.handleSubmit, _this.props.singleFieldSubmit, _this.props.snapshot);
              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
    _this.handleReset = function (e) {
      // Return form state to default
      e.preventDefault();
      _this.props.resetForm(_this.props.id, _this.props.snapshot);
    };
    props.initialiseForm(props.id);
    return _this;
  }
  _createClass(Form, [{
    key: 'getChildContext',
    value: function getChildContext() {
      // For controlling & validating fields
      return {
        validator: this.props.validator,
        formId: this.props.id,
        product: this.props.product,
        submit: this.handleSubmit
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.submittedForm(this.props.id);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('form', {
        id: this.props.id,
        onSubmit: this.handleSubmit,
        onReset: this.handleReset,
        autoComplete: this.props.autoComplete
      }, this.props.preventSubmitOnEnterKey && _react2.default.createElement('button', {
        type: 'submit',
        style: {
          display: 'none'
        },
        onClick: function onClick(e) {
          return e.preventDefault();
        }
      }), this.props.children);
    }
  }]);
  return Form;
}(_react.Component);
Form.propTypes = {
  // Form state stored at forms[id]
  id: _propTypes.string.isRequired,
  // passed through context for switches, urls etc
  product: _propTypes.string,
  // Fired on submit (after validation),
  // and receives whole form state
  handleSubmit: _propTypes.func.isRequired,
  // Contains tests & error messages
  validator: _propTypes.object,
  // Inputs go here
  children: _propTypes.node.isRequired,
  // If true only the activeField will be validated and submitted
  singleFieldSubmit: _propTypes.bool,
  // If true, when form is reset it will attempt to use a snapshotted version (if available)
  // Will also tell submission function to snapshot
  snapshot: _propTypes.bool,
  // If true stops enter key submitting the form
  preventSubmitOnEnterKey: _propTypes.bool,
  // From dispatchToProps
  initialiseForm: _propTypes.func.isRequired,
  submitForm: _propTypes.func.isRequired,
  submittedForm: _propTypes.func.isRequired,
  resetForm: _propTypes.func.isRequired,
  // From stateToProps
  validating: _propTypes.bool.isRequired,
  autoComplete: _propTypes.string
};
Form.defaultProps = {
  validator: {},
  product: undefined,
  singleFieldSubmit: false,
  snapshot: false,
  autoComplete: 'off',
  preventSubmitOnEnterKey: false
};
Form.childContextTypes = {
  validator: _propTypes.object.isRequired,
  formId: _propTypes.string.isRequired,
  submit: _propTypes.func.isRequired,
  product: _propTypes.string
};
exports.default = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    validating: !!(0, _formInfo.isSubmittingForm)(state, ownProps.id)
  };
}, {
  initialiseForm: _updateForm.initialiseForm,
  submitForm: _submission.submitForm,
  submittedForm: _submission.submittedForm,
  resetForm: _updateForm.resetForm
})(Form);